<template>
  <div class="wrap">
    <div class="list-time-select">
      <div class="flex-center">
        <van-icon name="arrow-left" @click="prevArrow" />
        <span style="margin: 0 5%" @click="selectDate">{{ date }}</span>
        <van-icon name="arrow" @click="nextArrow" />
      </div>
      <SelectTime
        ref="startmonth"
        :typeTime="'选择月份'"
        @time="handleTimeStartConfirm"
        :minDate="minDate"
        :maxDate="new Date()"
        type="year-month"
        :currentDate="startMinTime"
      />
    </div>
    <div class="list-number">
      <div class="image"><img :src="img" alt="" /></div>
      <div class="info">
        <p>
          共 <span style="color: #37a5da">{{ num || "0" }} </span>人上榜
        </p>
        <p>按考勤计划，应当出勤日期没有出勤或请假者</p>
      </div>
    </div>
    <div class="list-content">
      <van-collapse v-model="activeNames" v-if="dataList.length!='0'">
        <van-collapse-item
          :name="index + ''"
          class="vanitem"
          v-for="(classes, index) in dataList"
          :key="index"
        >
          <template #title>
            <div class="title">
              {{ classes.className }}（<span style="color: #37a5da">{{
                classes.userAttendances.length || "0"
              }}</span
              >人）
            </div>
          </template>
          <div class="content">
            <div
              class="info"
              v-for="child in classes.userAttendances"
              @click="hrefOtherPage(child, classes)"
              :key="child.userId"
            >
              <img :src="child.avatar" alt="" />
              <span>{{ child.userName }}</span>
              <div>
                缺勤<span style="color: #37a5da">{{ child.dayNum }}</span
                >天
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <van-empty description="暂无数据" v-else style="height:29rem"/>
    </div>
  </div>
</template>

<script>
// let data = [
//   {
//     className: "大一班",
//     userAttendances: [
//       {
//         userName: "王小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "李小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "张小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "大二班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 1,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "大三班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },

//   {
//     className: "中一班",
//     userAttendances: [
//       {
//         userName: "王小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "李小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "张小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "中二班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "中三班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },

//   {
//     className: "小一班",
//     userAttendances: [
//       {
//         userName: "王小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "李小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "张小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "小二班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
//   {
//     className: "小三班",
//     userAttendances: [
//       {
//         userName: "孟小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "孙小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//       {
//         userName: "赵小丽",
//         avatar:
//           "http://asiait-ai.oss-cn-beijing.aliyuncs.com/ai/76dffbda-4ed7-414d-86f3-839f8194cf7d.jpg",
//         dayNum: 21,
//       },
//     ],
//   },
// ];

import SelectTime from "@/components/subScribePopup/selectTime";
import moment from "moment";
import img from "@/assets/images/缺勤.png";
export default {
  data() {
    return {
      date: moment().format("YYYY-MM"),
      startTime:'',
      endTime:'',
      minDate: new Date(2020, 0),
      startMinTime: new Date(moment().format("YYYY-MM")),
      img,
      num: 0,
      activeNames: [],
      dataList: [],
    };
  },
  components: { SelectTime },
  mounted() {
    this.getAbsentWork()
  },
  methods: {
    async getAbsentWork() {
      this.startTime=this.date+'-01'
      let days=this.getDayNumByYearMonth(this.date.slice(0,4),this.date.slice(5,7))
      this.endTime=this.date+'-'+days
      const { data, code } = await this.$https.getAbsentWorkBySchoolId({
        schoolId: this.$store.state.schoolId,
        beginDate: this.startTime,
        endDate: this.endTime
      });
      if (code !== 200) {
        return false;
      }
      this.num=0
      if(data!=null){
        data.forEach(() => {
          for (let i = 0; i < data.length - 1; i++) {
            if (data[i].userAttendances.length < data[i + 1].userAttendances.length) {
              [data[i], data[i + 1]] = [data[i + 1], data[i]];
            } else if (
              data[i].userAttendances.length == data[i + 1].userAttendances.length
            ) {
              if (data[i].className < data[i + 1].className) {
                [data[i], data[i + 1]] = [data[i + 1], data[i]];
              }
            }
          }
        });
        this.dataList = data;
        for(var i=0;i<this.dataList.length;i++){
          this.num+=this.dataList[i].userAttendances.length
        }
      }else{
        this.dataList=[]
      }
    },
    //是否是闰年
    isLeapYear(year){
        if(year/4 == 0 && year/100 != 0){
            return true ;
        } else if (year/400 == 0){
            return true ;
        } else{
            return false ;
        }
    },
    //根据年月得到天数
    getDayNumByYearMonth(year,month){
        switch (month) {
            case '01':
            case '03':
            case '05':
            case '07':
            case '08':
            case '10':
            case '12':
                return 31;
                break;
            case '04':
            case '06':
            case '09':
            case '11':
                return 30;
                break;
            case '02':
                return this.isLeapYear(year) ? 29 : 28;
        }
    },
    //判断是否是ios系统
    appSource() {
      const u = navigator.userAgent, app = navigator.appVersion;
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isiOS
    },
    handleTimeStartConfirm(time) {
      var timeDate=time
      var ios=this.appSource()
      if(ios){
        timeDate= time.replace(/-/g,'/')
      }
      this.date = moment(new Date(timeDate)).format("YYYY-MM");
      this.getAbsentWork()
    },
    selectDate() {
      this.$refs.startmonth.showTimePopup = true;
    },
    prevArrow() {
      let date = new Date(
        new Date(this.date).setMonth(new Date(this.date).getMonth() - 1)
      );
      if (new Date(date).getTime() < new Date("2020-01").getTime()) return;
      this.date = moment(new Date(date)).format("YYYY-MM");
      this.getAbsentWork()
    },
    nextArrow() {
      let date = new Date(
        new Date(this.date).setMonth(new Date(this.date).getMonth() + 1)
      );
      if (new Date(date).getTime() > new Date().getTime()) return;
      this.date = moment(new Date(date)).format("YYYY-MM");
      this.getAbsentWork()
    },
    hrefOtherPage(child, classes) {
      console.log('缺勤榜参数',classes)
      let params = {
        appId: "wx196a8663a913cfe0",
        data: JSON.stringify({ ...child,classId:classes.classId, className: classes.className,current:this.date }),
        type: ["2"],
      };
      this.$router.push({
        path: "/studentMonthAttendance",
        query: params,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  .list-time-select {
    height: 40px;
    line-height: 40px;
  }
  .list-number {
    width: 90%;
    background: white;
    border-radius: 8px;
    margin-left: 5%;
    display: flex;
    align-items: center;
    padding: 8px 15px;
    .image {
      img {
        width: 40px;
        height: 40px;
      }
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 8px;
      p:nth-child(1) {
        font-size: 16px;
      }
      p:nth-child(2) {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .list-content {
    width: 90%;
    background: white;
    border-radius: 8px;
    margin-left: 5%;
    margin-top: 3%;
    overflow: scroll;
    .title {
      border-left: 3px solid #37a5da;
      height: 15px;
      font-size: 15px;
      line-height: 15px;
      padding-left: 5px;
    }
    .content {
      .info {
        display: flex;
        align-items: center;
        padding: 2% 0;
        border-bottom: 1px solid #f8f9fa;
        img {
          width: 34px;
          height: 34px;
          border-radius: 50%;
        }
        :nth-child(2) {
          font-size: 15px;
          margin-left: 5px;
          color: #323233;
        }
        :nth-child(3) {
          font-size: 14px;
          position: absolute;
          right: 15px;
        }
        &:last-child{
          border-bottom: none;
        }
      }
    }
  }
}
.vanitem ::deep .van-cell__title {
  display: flex;
  align-items: center;
}
</style>